export const VerificationMethodsEnum = {
	BIRTH_DATE: "BIRTHDAY",
	IBAN: "IBAN",
	SMS: "MSISDN",
	CUSTOMER_NUMBER: "CUSTOMER_NUMBER",
	ZIP_CODE: "ZIP_CODE"
};
